import { createTheme } from "@mui/material/styles";

// SGT için özel tema renkleri
const theme = createTheme({
  palette: {
    primary: {
      main: "#1a5276", // Koyu mavi
      light: "#2980b9",
      dark: "#154360",
      contrastText: "#fff",
    },
    secondary: {
      main: "#f39c12", // Altın sarısı (tarımsal ürünleri temsil eden)
      light: "#f5b041",
      dark: "#d68910",
      contrastText: "#fff",
    },
    success: {
      main: "#27ae60", // Yeşil (tarım/doğa temasını destekler)
      light: "#2ecc71",
      dark: "#229954",
    },
    error: {
      main: "#c0392b",
    },
    background: {
      default: "#ffffffff", // Bu hala kullanılabilir
      paper: "#ffffff",
      // 👇 Yeni özel alanlar
      gradient: "linear-gradient(135deg, #161a02d7, #171616)",
      wheatOverlay: `linear-gradient(rgba(255, 255, 255, 0.2), rgba(255,255,255,0.2)), url('/images/wheat-228726.jpg')`,
    },
    text: {
      primary: "#2c3e50",
      secondary: "#898d7f",
    },
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: "2.5rem",
      "@media (min-width:600px)": {
        fontSize: "3.5rem",
      },
    },
    h2: {
      fontWeight: 600,
      fontSize: "2rem",
      "@media (min-width:600px)": {
        fontSize: "2.75rem",
      },
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.75rem",
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.5rem",
    },
    h5: {
      fontWeight: 500,
      fontSize: "1.25rem",
    },
    h6: {
      fontWeight: 500,
      fontSize: "1rem",
    },
    button: {
      fontWeight: 500,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 24px",
          fontWeight: 500,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          },
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#2980b9",
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: "#f5b041",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          borderRadius: 12,
          transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#2980b9",
            },
          },
        },
      },
    },
  },
});

export default theme;
